import React, { useState } from "react"
import { Container, useTick } from "@inlet/react-pixi"
import { clamp } from "utils/math"

const FadeIn = ({ children, duration = 250 }) => {
  const [alpha, setAlpha] = useState(0)
  useTick((delta, x) => setAlpha(prev => clamp(prev + x.elapsedMS / duration)))
  return <Container alpha={alpha}>{children}</Container>
}

export default FadeIn
